import { Hidden } from 'braid-design-system';

import { useIsHomepageGenAIChatMobileDrawerEnabled } from 'src/store/featureFlags/hooks';

type CareerFeedMobileWebFeatureFlagContainerProps = {
  mobileView: React.ReactNode;
  tabletAndAboveView: React.ReactNode;
};

export const CareerFeedMobileWebFeatureFlagContainer: React.FC<
  CareerFeedMobileWebFeatureFlagContainerProps
> = ({ mobileView, tabletAndAboveView }) => {
  const isHomepageGenAIChatMobileDrawerEnabled =
    useIsHomepageGenAIChatMobileDrawerEnabled();

  if (isHomepageGenAIChatMobileDrawerEnabled) {
    return (
      <>
        <Hidden above="mobile">{mobileView}</Hidden>
        <Hidden below="tablet">{tabletAndAboveView}</Hidden>
      </>
    );
  }

  return tabletAndAboveView;
};
